import React, { useState } from 'react'
import { Card, Spin } from 'antd'
import {
	Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis
} from 'recharts'
import moment from 'moment'

import { GraphDataEntry, RatingDetail } from '../../../reducers/ratings/actions' // alebo odkiaľ to importuješ

interface RatingsStatusPerMonthProps {
	graphData: GraphDataEntry[] // <-- externé dáta priamo z getRatings
}

const RATING_KEYS = [
	{ key: 'ONE_STAR', label: '1 ★' },
	{ key: 'TWO_STARS', label: '2 ★' },
	{ key: 'THREE_STARS', label: '3 ★' },
	{ key: 'FOUR_STARS', label: '4 ★' },
	{ key: 'FIVE_STARS', label: '5 ★' }
] as const

const RATING_COLORS: Record<string, string> = {
	ONE_STAR: '#F92316',
	TWO_STARS: '#FF4400',
	THREE_STARS: '#FF8800',
	FOUR_STARS: '#FFAA00',
	FIVE_STARS: '#FFD700'
}

const RatingsStatusPerMonth: React.FC<RatingsStatusPerMonthProps> = ({ graphData }) => {
	const [activeRating, setActiveRating] = useState<keyof typeof RATING_COLORS | null>(null)
	const [selectedDetails, setSelectedDetails] = useState<RatingDetail[]>([])
	const [selectedMonth, setSelectedMonth] = useState<string | null>(null)

	const CustomTooltip = ({ active, payload, label }: any) => {
		if (active && payload?.length && activeRating) {
			const entry = payload.find((p: any) => p.dataKey === activeRating)
			const details: RatingDetail[] = entry?.payload?.details?.[activeRating] || []
			return (
				<div style={{ backgroundColor: '#fff', padding: 10, border: '1px solid #ccc' }}>
					<strong>{`Mesiac: ${label}`}</strong>
					<p style={{ color: entry.color }}>{`${RATING_KEYS.find((r) => r.key === activeRating)?.label}: ${entry.value}`}</p>
					{details.map((d, i) => (
						<div key={i}>
							<small>{d.address}</small><br />
							<small>{d.author}</small><br />
							<small>{moment(d.createdAt).format('DD.MM.YYYY')}</small>
							<hr />
						</div>
					))}
				</div>
			)
		}
		return null
	}

	const handleBarClick = (data: GraphDataEntry, ratingKey: keyof typeof RATING_COLORS) => {
		if (selectedMonth === data.date && activeRating === ratingKey) {
			setSelectedMonth(null)
			setActiveRating(null)
			setSelectedDetails([])
		} else {
			setSelectedMonth(data.date)
			setActiveRating(ratingKey)
			// setSelectedDetails(data.details?.[ratingKey] || [])
		}
	}

	return (
		<Card hoverable className={'my-2'}>
			<Spin spinning={false}>
				<div className={'font-bold mb-2'}>Hodnotenia za mesiac</div>
				<BarChart width={600} height={400} data={graphData}>
					<CartesianGrid strokeDasharray="3 3" />
					<XAxis dataKey="date" />
					<YAxis />
					<Tooltip content={<CustomTooltip />} />
					<Legend />
					{RATING_KEYS.map(({ key, label }) => (
						<Bar
							key={key}
							name={label}
							dataKey={key}
							stackId="a"
							fill={RATING_COLORS[key]}
							onMouseOver={() => setActiveRating(key)}
							onMouseOut={() => setActiveRating(null)}
							onClick={({ payload }) => handleBarClick(payload, key as keyof typeof RATING_COLORS)}
						/>
					))}
				</BarChart>
				{selectedMonth && selectedDetails.length > 0 && (
					<div style={{ marginTop: 20 }}>
						<h4>{`${selectedMonth} – ${RATING_KEYS.find((r) => r.key === activeRating)?.label}`}</h4>
						<ul>
							{selectedDetails.map((d, i) => (
								<li key={i}>
									{d.address} | {d.author} | {moment(d.createdAt).format('DD.MM.YYYY')}
								</li>
							))}
						</ul>
					</div>
				)}
			</Spin>
		</Card>
	)
}

export default RatingsStatusPerMonth
